export default function clone_object(obj) {
  const clone = Array.isArray(obj) ? [] : {};
  for (let key in obj) {
    if (
      typeof obj[key] == "object" &&
      obj[key] != null &&
      !(obj[key] instanceof File)
    ) {
      clone[key] = clone_object(obj[key]);
    } else {
      clone[key] = obj[key];
    }
  }
  return clone;
}
